var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactiveCompanyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1297 12.1652L13.6729 10.7123V5.41049H8.37502L7.00619 4.04566V2.74383H5.70835L4.25152 1.29083H8.46302V3.95749H15.1297V12.1652ZM14.1577 15.1352L12.5312 13.534H1.54935V2.52683L0.666687 1.64016L1.63985 0.666992L15.1349 14.158L14.1577 15.1352ZM3.00619 12.0772H4.33952V10.7438H3.00619V12.0772ZM3.00619 9.41049H4.33952V8.07716H3.00619V9.41049ZM3.00619 6.74383H4.33952V5.41049H3.00619V6.74383ZM5.67285 12.0772H7.00619V10.7438H5.67285V12.0772ZM5.67285 9.41049H7.00619V8.07716H5.67285V9.41049ZM8.33952 12.0772H11.0824L9.74902 10.7438H8.33952V12.0772ZM12.3395 8.07716H11.1217L11.0062 7.96149V6.74383H12.3395V8.07716Z",
    fill: "#EF183B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveCompanyIcon);
export default __webpack_public_path__ + "static/media/InactiveCompanyIcon.68e66a23387201ff3322ae205edecd85.svg";
export { ForwardRef as ReactComponent };